import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {CmsCopy, PaginatiorInfo} from '../../../graphql/common.datatypes';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
        maxWidth: '90vw'
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    cmsCopys: CmsCopy[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    selectedCmsCopy?: CmsCopy,
    setSelectedCmsCopy?: (party: CmsCopy) => void,
    onRowClick?: (party: CmsCopy) => void,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedCmsCopy, setSelectedCmsCopy, cmsCopys, onRowClick, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                <CardHeader
                    title={'CMS Copy'}
                />
                <Divider/>
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table style={{width: '100%'}}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell style={{width: 100}}>Id</TableCell>
                                        <TableCell style={{width: 200}}>Key</TableCell>
                                        <TableCell style={{width: 100}}>Is HTML</TableCell>
                                        <TableCell>Body</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {cmsCopys.map(cmsCopy => {
                                        return (
                                            <TableRow
                                                hover
                                                key={cmsCopy.id}
                                                selected={selectedCmsCopy === cmsCopy}
                                                onClick={() => onRowClick ? onRowClick(cmsCopy) : history.push('/cms_copy/' + cmsCopy.id)}
                                            >
                                                <TableCell>{cmsCopy.id}</TableCell>
                                                <TableCell>{cmsCopy.key}</TableCell>
                                                <TableCell>{cmsCopy.is_html? 'yes' : ''}</TableCell>
                                                <TableCell>{cmsCopy.body}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
